import {
  GET_HUBSPOT_DEALS,
  GET_HUBSPOT_DEALS_SUCCESS,
  GET_HUBSPOT_DEALS_FAILURE,
} from './constants';

export const getHubspotDeals = () => ({
  type: GET_HUBSPOT_DEALS,
  payload: {},
});

export const getHubspotDealsSuccess = (hubspotData) => ({
  type: GET_HUBSPOT_DEALS_SUCCESS,
  payload: hubspotData,
});

export const getHubspotDealsFailure = (error) => ({
  type: GET_HUBSPOT_DEALS_FAILURE,
  payload: { message: error },
});
